import React, { useState, useEffect } from 'react';
import { teamService } from '../services/api';

export default function Team() {
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadTeam = async () => {
      try {
        const response = await teamService.getTeam();
        setPeople(response.data);
      } catch (err) {
        console.error('Error loading team:', err);
        setError('Error al cargar el equipo');
      } finally {
        setLoading(false);
      }
    };

    loadTeam();
  }, []);
  if (loading) return <div className="text-center py-12">Cargando equipo...</div>;
  if (error) return <div className="text-center py-12 text-red-600">{error}</div>;
  if (!people?.length) return null;

  return (
    <section className='bg-gray-50'>
      <div className='max-w-6xl mx-auto px-4 py-12'>
        <h2 className='text-2xl font-bold mb-6'>Profesionales Trabajando por La Guardia</h2>
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6'>
          {people.map(p => (
            <div key={p.id} className='bg-white rounded-lg p-4 shadow-sm text-center'>
              <div className='mx-auto h-24 w-24 rounded-full bg-gray-200 flex items-center justify-center'>{p.name.split(' ').map(n => n[0]).slice(0,2).join('')}</div>
              <div className='mt-3 font-semibold'>{p.name}</div>
              <div className='text-sm text-gray-600'>{p.role}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
